<si-landing-page
  [heading]="'APP.DESCRIPTION' | translate"
  [subheading]="'APP.HEADING' | translate"
  [subtitle]="'APP.CLAIM' | translate"
  backgroundImageUrl="./assets/images/landing.svg"

  [links]="links"
  [availableLanguages]="availableLanguages"
>
  <button type="submit" class="btn btn-primary w-100" (click)="onLogin()">
    {{ 'APP.LOGIN' | translate }}
  </button>
</si-landing-page>

<ng-template #legalTpl>
  <div class="modal-header">
    <h4 class="modal-title">{{ legalModalTitle }}</h4>
  </div>
  <div class="modal-body p-0">
    <iframe
      #iframeLegalEl
      [src]="legalModalUrl"
      [title]="legalModalTitle"
      class="landing-legal-iframe"
      sandbox="allow-same-origin"
      referrerpolicy="no-referrer"
      (load)="onIframeLoad(iframeLegalEl)"
    ></iframe>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="closeLegalModal()">OK</button>
  </div>
</ng-template>
